var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confListIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 394",
    transform: "translate(1663 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "confListIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 487",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ListIcon",
    transform: "translate(-1663 -46)",
    clipPath: "url(#confListIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ListIcon",
    transform: "translate(1663 46)",
    clipPath: "url(#confListIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 445"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 855",
    d: "M31.565 3H4.436A1.435 1.435 0 003 4.435v27.128A1.437 1.437 0 004.436 33h27.129A1.437 1.437 0 0033 31.563V4.436A1.436 1.436 0 0031.565 3M11.656 28.076H7.688v-3.968h3.968v3.969zm0-7.656H7.688v-3.969h3.968v3.969zm0-7.657H7.688V8.8h3.968v3.968zm14.1 14.286h-10.7a.957.957 0 110-1.914h10.7a.957.957 0 110 1.914m0-7.656h-10.7a.957.957 0 110-1.914h10.7a.957.957 0 110 1.914m.576-7.657h-10.7a.957.957 0 010-1.914h10.7a.957.957 0 110 1.914",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfListIcon);
export default __webpack_public_path__ + "static/media/confListIcon.b956177cd6236e0c.svg";
export { ForwardRef as ReactComponent };